<template>
  <div class="selection-bar">
    <span class="selection-text">
      <strong>{{ count }}</strong>
      {{ count === 1 ? 'item selecionado' : 'itens selecionados' }}
      · {{ professionals }} {{ professionals === 1 ? 'profissional' : 'profissionais' }}
      · {{ total | currency }}
    </span>
    <span class="selection-actions">
      <button class="btn btn-sm btn-link" @click="$emit('clear')">
        Limpar seleção <kbd>Esc</kbd>
      </button>
      <button class="btn btn-sm btn-primary btn-icon btn-icon-left tooltip tooltip-left"
              :data-tooltip="tooltip"
              :class="{loading: saving}" :disabled="saving || !canConsolidate"
              @click="$emit('consolidate')">
        <fa-icon :icon="['fal', 'file-invoice-dollar']"/>Consolidar
      </button>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 0,
    },
    professionals: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    canConsolidate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tooltip() {
      return this.canConsolidate
        ? 'Cria uma conta a pagar por profissional'
        : 'Sem permissão para consolidar';
    },
  },
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    onKeydown(event) {
      if (event.key === 'Escape') {
        this.$emit('clear');
      }
    },
  },
};
</script>
